import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFilteredStudents, fetchStudentsAsync } from '../../../features/students/studentsSlice';
import { searchStudent } from '../../../features/students/utils/studentSearch';
import { AiOutlineSearch } from 'react-icons/ai';
import AddStudent from './AddStudent'; // Import the AddStudent form component
import { fetchGroups } from '../../../features/sections/sectionsAPI';
import { FaPlus } from 'react-icons/fa';
import LoadingSpinner from '../../LoadingSpinner';

const Students = () => {
  const dispatch = useDispatch();
  const students = useSelector(selectFilteredStudents);
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddStudent, setShowAddStudent] = useState(false); // State to control the visibility of the AddStudent form
  const [studentToUpdate, setStudentToUpdate] = useState(null);
  const studentListRef = useRef(null);
  const [groups, setGroups] = useState([]);
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [forceUpdateStudents, setForceUpdateStudents] = useState(false);// State variable to trigger re-render
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
      fetchAllGroups(storedToken); // Fetch groups when token is set
    }
  }, []);

  const fetchAllGroups = async (token) => {
    try {
      const allGroups = await fetchGroups(token);
      setGroups(allGroups);   
      setLoading(false);   
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  };

  useEffect(() => {
    // Fetch students when the component mounts
    dispatch(fetchStudentsAsync(token)); // Replace `token` with your token value
  }, [dispatch, token,forceUpdateStudents]);

  let filteredStudents = searchStudent(students, searchQuery);
  filteredStudents = filteredStudents.sort((a, b) => a.name.localeCompare(b.name)); // Sort students alphabetically

  const scrollToLetter = (letter) => {
    if (studentListRef.current) {
      const letterElement = studentListRef.current.querySelector(`#letter-${letter}`);
      if (letterElement) {
        letterElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };
  
  const handleStudentUpdate = () => {
    // This function will be called when a student is added or updated
    setForceUpdateStudents(prev => !prev);
  };
  //update student data
  const handleUpdateStudent = (studentId) => {
    // Find the student by ID from the students array
    const studentToUpdate = students.find(student => student.id === studentId);
    // Pass the student data and token to the AddStudent component
    setShowAddStudent(true); // Only set to true to show the AddStudent form
    setStudentToUpdate(studentToUpdate); // Set the student data to state

  };
  
  // Function to toggle the visibility of the AddStudent form
  const toggleAddStudentForm = () => {
    setShowAddStudent(!showAddStudent);
  };

  // Function to handle closing the AddStudent form
  const handleCloseAddStudent = () => {
    setShowAddStudent(false);
    setStudentToUpdate(null); // Reset the studentToUpdate state
  };
  
//   Loading until fetching data
if(loading){
  return(

      <LoadingSpinner/>
  )
}
  return (
    <div className="py-2 pr-2 pl-4 w-full" >
      <h2 className="sections-title text-2xl font-bold my-4 text-center">Students</h2>
      <div className="flex items-center justify-center mb-4 w-full">
        <div className=" flex items-end rounded-md bg-gray-100  py-1 ml-10 md:ml-0 mr-4 w-full sm:w-1/2">
          <input
            type="text"
            placeholder="Search by name"
            value={searchQuery}
            onChange={handleSearchChange}
            className="pl-4 py-3 mr-2 bg-gray-100 focus:outline-none w-full" 
          />
        
          <AiOutlineSearch className="text-gray-500 w-11 h-10 sm:h-11 my-1 px-1 border-l border-black-300" />
        </div>
       
      </div>
      <div className="flex">
        <div className="w-10">
          <ul className="flex flex-col gap-y-2 text-center">
            {alphabet.map((letter) => (
              <li key={letter} className="cursor-pointer" onClick={() => scrollToLetter(letter)}>
                {letter}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex-grow" ref={studentListRef}>
          <ul className="divide-y divide-gray-200 cursor-pointer">
            {filteredStudents.map((student) => (
            <li key={student.id} className="py-2" id={`letter-${student.name[0].toUpperCase()}`}
            onClick={() => handleUpdateStudent(student.id)}>
            {student.name}
          </li>
            ))}
          </ul>
        </div>
      </div>
      <button onClick={toggleAddStudentForm}       
       className="fixed text-white rounded-full p-3 bg-gray-500 hover:bg-gray-600"
                    style={{ left: '50%', bottom: '5%', transform: 'translateX(-50%)', zIndex: '40' }}>
  <FaPlus />
</button>

{showAddStudent && 
  <AddStudent onClose={handleCloseAddStudent} groups={groups} studentToUpdate={studentToUpdate} onStudentUpdate={handleStudentUpdate} />

}

    </div>
  );
};

export default Students;
